import { productGroupService } from '@/projects/platform/services/product-group-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { t } from 'i18next';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const mainStore =  createCustomStore({
    key: 'id',
    load: productGroupService.listProductGroup,
    insert: productGroupService.createProductGroup,
    update: productGroupService.updateProductGroup,
    remove: productGroupService.deleteProductGroup,
    byKey: (key, loadOptions) => {
        if (key) {
            loadOptions.filter = ["Id", "=", key];
        }
    },
});

const ProductGroupList = () => {

    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };

    return (
        <>
            <DataGridWrapper
                props={{ id: 'product-list', wordWrapEnabled: false }}
                permissonCode='Product.ProductGroup'
                onRowUpdating={handleRowUpdating}
                datasource={mainStore}
                filterVisible={true}
                headerFilterVisible={true}
                searchPanelVisible={true}
                editingConfig={{ mode: 'row', allowAdding: true, allowDeleting: true, allowUpdating: true, confirmDelete: true, confirmDeleteMessage: RemoveMessage('Product Group') }}
                pagerVisible={true}
                enableCustomToolbarContent={false}
                columns={[
                    { dataField: 'categoryCode1', caption: t('product_group_code1') },
                    { dataField: 'categoryName1', caption: t('product_group_name1') },
                    { dataField: 'categoryCode2', caption: t('product_group_code2') },
                    { dataField: 'categoryName2', caption: t('product_group_name2') },
                    { dataField: 'categoryCode3', caption: t('product_group_code3') },
                    { dataField: 'categoryName3', caption: t('product_group_name3') },
                    { dataField: 'categoryCode4', caption: t('product_group_code4') },
                    { dataField: 'categoryName4', caption: t('product_group_name4') },
                    { dataField: 'categoryCode5', caption: t('product_group_code5') },
                    { dataField: 'categoryName5', caption: t('product_group_name5') },
                ]}
            />
        </>
    )
}
export default ProductGroupList